import { inject, NgModule } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '../environments/environment';
import { InMemoryCache } from '@apollo/client/core';

@NgModule({
    providers: [
        provideApollo(() => {
            const httpLink = inject(HttpLink);

            return {
                link: httpLink.create({ uri: `${environment.protectedResources.api.endpoint}/graphql` }),
                cache: new InMemoryCache(),
                defaultOptions: {
                    mutate: {
                        errorPolicy: 'all'
                    }
                }
            };
        })
    ],
})
export class GraphQLModule { }
